<div
  class="relative mb-6 flex w-full items-center justify-between pr-4 text-cobalt-500 shadow-none"
  *ngxPermissionsOnly="Permission.TICKETING_WRITE"
>
  <!-- CLICKABLE AREA -->
  <div
    #helpCtaRoot
    class="relative flex cursor-pointer flex-nowrap items-center pl-2 md:basis-full md:flex-wrap"
    (click)="toggleBlimp()"
  >
    <div
      class="mr-2 h-10 w-10 bg-[url('/assets/images/icons_legacy/img_user_nitel@2x.png')] bg-contain bg-center bg-no-repeat"
    ></div>

    <div
      class="flex flex-row-reverse items-start text-lg text-black md:text-xl"
    >
      Have a question?
    </div>

    <div class="relative -mt-2 ml-1">
      <mat-icon
        class="!h-4 !w-4 text-blue-500"
        svgIcon="question-mark"
      ></mat-icon>

      <div
        #helpBlimpView
        class="absolute left-1/2 top-8 z-10 block w-64 -translate-x-1/2 rounded-xl bg-blue-950 px-4 py-2 text-center text-white opacity-0 shadow-[0_2px_8px_rgba(0,0,0,.1)] transition-opacity duration-200 ease-in-out"
        [ngClass]="(showBlimp$ | async) ? 'z-20 opacity-95' : ''"
      >
        <div class="arrow-up mx-auto -mt-4 mb-1 h-2 w-4"></div>
        <h3 class="text-sm font-semibold">Need Help?</h3>
        <p class="text-[13px] font-normal">
          Create a ticket with the subject “Billing” and we&apos;ll take it from
          there!
        </p>
      </div>
    </div>
  </div>

  @if (hasInvoice) {
    <ng-container *ngxPermissionsOnly="Permission.TICKETING_WRITE">
      <button class="btn-primary" (click)="onCreateTicket()">
        Create Ticket
      </button>
    </ng-container>
  }
</div>
